import { Order } from 'entities/orders';
import { Deposit, OrderBookingData } from 'entities/orders/model/types';
import { isArrayEquals } from 'shared/lib/core';

export const compareOrderChanges = (
	orderDetail: Order | null,
	bookingData: OrderBookingData,
) => {
	return (
		orderDetail?.dt_start === bookingData.dt_start &&
		orderDetail.participants_count === bookingData.participants_count &&
		orderDetail.duration === bookingData.duration &&
		orderDetail.appointment?.hold_resources === bookingData.hold_resources &&
		orderDetail.notes === bookingData.notes &&
		(orderDetail.prepayment_amount || '') === bookingData.prepayment_amount &&
		orderDetail.person?.name === bookingData.person?.name &&
		isArrayEquals(orderDetail.tags, bookingData.tags)
	);
};

type TCompareDepositesArg = Deposit | null | undefined

export const compareDeposites = (orderDetailDeposit: TCompareDepositesArg, bookingDataDeposit: TCompareDepositesArg) => {
  if (orderDetailDeposit?.amount == '0') orderDetailDeposit = null;
  if (bookingDataDeposit?.amount == '0') bookingDataDeposit = null;

  if (!orderDetailDeposit&&!bookingDataDeposit) return true;
  if ((orderDetailDeposit&&!bookingDataDeposit)||(!orderDetailDeposit&&bookingDataDeposit)) return false;


  const orderDetailDepositAmount = typeof orderDetailDeposit?.amount === 'string' ? parseFloat(orderDetailDeposit?.amount) : orderDetailDeposit?.amount;
  const bookingDataDepositAmount = typeof bookingDataDeposit?.amount === 'string' ? parseFloat(bookingDataDeposit?.amount) : bookingDataDeposit?.amount;
  
  return (
    orderDetailDepositAmount === bookingDataDepositAmount &&
    orderDetailDeposit?.due_date === bookingDataDeposit?.due_date &&
    orderDetailDeposit?.provider?.id === bookingDataDeposit?.provider_id
  )
}